/* Just Crisps — product-card quantity stepper + AJAX add to basket.
   Integrates with Dawn's native cart drawer / cart-icon-bubble; falls back to
   /cart on any error so an add is never lost. */
(function () {
  'use strict';

  function qtyOf(card) {
    var v = card && card.querySelector('[data-jc-val]');
    return v ? (parseInt(v.textContent, 10) || 1) : 1;
  }

  function refreshDawnCart(sections) {
    try {
      if (sections && sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        var parsedB = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var newB = parsedB.getElementById('cart-icon-bubble');
        if (bubble && newB) bubble.innerHTML = newB.innerHTML;
      }
      var drawer = document.querySelector('cart-drawer');
      if (drawer && sections && sections['cart-drawer']) {
        var parsedD = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var newD = parsedD.querySelector('cart-drawer');
        if (newD) {
          drawer.innerHTML = newD.innerHTML;
          drawer.classList.remove('is-empty');
          if (typeof drawer.open === 'function') { drawer.open(); }
          else { drawer.classList.add('active'); document.body.classList.add('overflow-hidden'); }
          return true;
        }
      }
    } catch (e) { /* fall through */ }
    return false;
  }

  document.addEventListener('click', function (e) {
    // Quantity stepper
    var step = e.target.closest('[data-jc-step]');
    if (step) {
      var box = step.closest('[data-jc-qty]');
      var val = box && box.querySelector('[data-jc-val]');
      if (!val) return;
      var n = (parseInt(val.textContent, 10) || 1) + parseInt(step.getAttribute('data-jc-step'), 10);
      if (n < 1) n = 1;
      val.textContent = n;
      return;
    }

    // Add to basket
    var add = e.target.closest('[data-jc-add]');
    if (!add) return;
    e.preventDefault();
    var id = add.getAttribute('data-variant-id');
    if (!id) return;
    var card = add.closest('.jc-card') || add.closest('[data-jc-buy]');
    var qty = qtyOf(card);
    var label = add.textContent;
    add.disabled = true;
    add.textContent = 'Adding…';

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: id, quantity: qty }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (res) {
        refreshDawnCart(res.sections);
        // Bump the header "Basket · N" pill count
        Array.prototype.forEach.call(document.querySelectorAll('[data-jc-basket-count]'), function (el) {
          el.textContent = (parseInt(el.textContent, 10) || 0) + qty;
        });
        add.textContent = 'Added ✓';
        setTimeout(function () { add.textContent = label; add.disabled = false; }, 1300);
      })
      .catch(function () {
        add.textContent = label;
        add.disabled = false;
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      });
  });
})();
